module.exports = __webpack_public_path__ + "475d6a8d489f327fc6738042682a1b35.pdf";